// Which earlier step a data-dependent step is missing, read from the same React Query caches the views already use.
import { useProject } from '@/hooks/use-projects';
import { useCanvasData } from '@/hooks/use-canvas-data';
import type { NodeMetadata } from '@/services/canvas-mappers';
import type { StepId } from '@/features/project/step-status';
import {
  derivePrerequisiteInputs,
  missingPrerequisite,
  type HintedStepId,
} from '@/features/project/step-prerequisites';

// undefined until both the project and the canvas have loaded: a loading graph
// must never read as an empty one (the affinity board follows the same rule).
export function useMissingPrerequisite(projectId: string, stepId: HintedStepId): StepId | null | undefined {
  const { data: project } = useProject(projectId);
  const { data: canvas, isSuccess } = useCanvasData(projectId);
  if (!project || !isSuccess) return undefined;
  const nodes = (canvas?.nodes ?? []).map((n) => ({
    type: n.type,
    metadataSource: (n.data?.metadata as NodeMetadata | undefined)?.source,
    title: (n.data as { label?: string } | undefined)?.label,
  }));
  return missingPrerequisite(stepId, derivePrerequisiteInputs(nodes, !!project.idea?.trim()));
}
